export const frontmatter = {
  category: 'guia',
  title: 'What to Pack for Ilha do Mel: Complete Checklist 2026',
  excerpt: 'Don\'t forget anything on your trip to Ilha do Mel. Complete checklist with essential items, what you don\'t need to bring, and tips from locals for a light and worry-free trip.',
  publishedAt: '2026-04-23',
  author: 'Guia Ilha do Mel',
  tags: ['checklist', 'dicas-praticas', 'o-que-levar'],
  coverImage: '/images/hero-bg.jpg',
  readingTime: '5 min',
};

What to Pack for Ilha do Mel: Complete Checklist

Ilha do Mel is a destination without cars, ATMs, and limited infrastructure. **Traveling light and prepared** makes all the difference between a smooth trip and a series of setbacks.

This checklist was compiled with tips from residents and people who have been there dozens of times.

---

Before leaving home

Documents

- [ ] RG or CNH (document with photo)

- [ ] Proof of guesthouse reservation
- [ ] Cash (PIX works, but the signal is unstable)

- [ ] Debit/credit card (for emergencies in Paranaguá/Pontal)

**Local tip:** Bring at least R$300-500 in cash for a 2-3 day stay. Almost no kiosks accept cards.

---

Clothing and footwear

| Item | Quantity | Note |

| ---------------------- | ---------- | ----------------------------------------------- |

| Bikini/swim trunks | 2-3 | Doesn't dry quickly in the island's humidity |

| Beach towel | 1 | Lightweight and microfiber takes up less space |

| Lightweight T-shirts | 3-4 | Cotton or technical fabric |

| Shorts | 2-3 | For hiking and beach |

| Lightweight pants | 1 | For hiking and cool nights |

| Sweatshirt/light jacket | 1 | Windy at night, even in summer |

| Flip-flops | 1 pair | For everyday use on the sand |

| Hiking shoes | 1 pair | **Essential** for hiking (do not wear sandals) |

| Hat/cap | 1 | Sun protection is essential |

| Sunglasses | 1 | With UV protection |

---

Hygiene and health

- [ ] Sunscreen **SPF 50+** (the sun reflects off the sand and burns more)

- [ ] Insect repellent
- [ ] After-sun moisturizer
- [ ] Shampoo and soap (the guesthouse may not provide them)

- [ ] Toothbrush and toothpaste

- [ ] Motion sickness medication (boat crossings can be rough)

- [ ] Pain reliever (dipyrone/paracetamol)

- [ ] Bandages and antiseptic

- [ ] Condoms (there are no pharmacies on the island)

**Attention:** There is no pharmacy on Ilha do Mel. Bring all the medications you may need.

---

Electronics

- [ ] Cell phone charger + power bank

- [ ] Headphones (the island is quiet — take advantage of it)

- [ ] Camera (optional — the scenery calls for it)

- [ ] Flashlight or cell phone with flashlight (streets are unlit at night)

- [ ] Power adapter (check with the guesthouse)

---

To the beach

- [ ] Snorkel mask (optional — the water is crystal clear)

- [ ] Small cooler bag (for water and snacks)

- [ ] Reusable water bottle

- [ ] Reusable bag (there are no plastic bags on the island)

- [ ] Book/e-reader (the beach invites you to disconnect)

---

What NOT to bring

| Item | Why leave it at home |

| --------------------- | ---------------------------------------------------- |

| Suitcase with wheels | Sandy and rocky streets — you'll be carrying it on your back |

| Hair dryer | Electricity is precious and few guesthouses can handle it |

| Kitchen utensils | There is no shared kitchen — eat at the restaurants |

| Luxury clothes | Rustic environment and sand everywhere |

| Meal vouchers/VR | Not accepted anywhere |

---

Backpack vs. Suitcase: Which one to take?

**A backpack is the best option.** Without exception.

- There are no cars on the island — you carry everything on your back.

- Sand, stone, and dirt roads make wheeled suitcases useless.

- The boat crossing requires you to carry your belongings to the guesthouse.

**Golden rule:** if you can't carry it for 1 km of trail by yourself, don't take it.

---

Quick checklist for 2 days

```
☐ RG + reserva da pousada
☐ R$ 300-500 em espécie
☐ 2 biquínis + 3 camisetas + 2 shorts
☐ Tênis de trilha + chinelo
☐ Protetor solar FPS 50 + repelente
☐ Power bank + carregador
☐ Remédios básicos
☐ Mochila (não mala!)
```

---

Final tip: travel light.

Ilha do Mel rewards those who travel light. Less luggage = more freedom to explore trails, climb the lighthouse, and walk between villages without the weight on your back.

Want to know how to get to Ilha do Mel, where to stay, and how much it costs? Our complete guide to Ilha do Mel has ready-made itineraries, budgets by profile, and tips from locals to help you plan the perfect trip.